<sn-icon-button
  class="file-attachment-button"
  icon="attach_file"
  (click)="fileAttachment.click()"
></sn-icon-button>

<input
  #fileAttachment
  id="file-attachment"
  class="hidden"
  type="file"
  multiple
  (change)="handleFiles(fileAttachment.files); fileAttachment.value = ''"
/>

<textarea
  class="message-textarea"
  [placeholder]="'communication.chat.writeMessage' | t"
  cdkTextareaAutosize
  cdkAutosizeMinRows="1"
  cdkAutosizeMaxRows="5"
  [(ngModel)]="channel.currentMessage"
  (keyup)="onMessageEntering()"
  (keydown.enter)="sendMessage($event)"
></textarea>
<sn-icon-button [disabled]="!channel.currentMessage" (click)="sendMessage()"
  ><sn-icon>send</sn-icon></sn-icon-button
>
